import tr from "@/common/utils/tr";

/**
 *
 * @param {*} msgChatPost
 * @returns
 */
export const renderStatusSendMsgError = (msgChatPost) => {
    if (msgChatPost?.insertFail) {
        return (
            <div className="div-msg-chat-fail">
                <span className="spMsgFail">{tr('Failed to send')}. </span>
                <span className="btnOption-chat-fail" role="button">
                    {tr('Resend')}
                </span>
                {' '}{tr('or')}{' '}
                <span className="btnOption-chat-fail" role="button">
                    {tr('delete')}
                </span>
                ?
            </div>
        );
    }
    return null;
};
